import { createStore, compose, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { enableBatching } from 'redux-batched-actions';
import reducers from './reducers';
import initStore from './init';
import history from './history';

const routerHistory = routerMiddleware(history);

export const buildStore = () => {
	// prepare store for redux dev tools
	// reference: https://github.com/zalmoxisus/redux-devtools-extension#usage
	/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION__"] }] */
	// const preloadedState =
	// 	process.env.NODE_ENV === 'development'
	// 		? window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
	// 		: undefined;
	// return createStore(
	// 	enableBatching(reducers),
	// 	preloadedState,
	// 	applyMiddleware(thunk, routerHistory),
	// );

	return createStore(
		enableBatching(reducers),
		applyMiddleware(thunk, routerHistory),
	);
};

const store = buildStore();
// Get any saved state from Session Storage and subcribe as needed.
initStore(store);

export default store;
